<template>
  <div v-if="this.$route.query.shop_id >= 1" >
    <router-view/>
  </div>
  <div v-else class="faq">

    <Table :columns="columns" :data="data">
      <template slot-scope="{ row, index }" slot="id">
        <span>{{ row.id }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="url">
        <Poptip trigger="hover" :transfer="true" title="图片详情">
          <div class="info-pop" slot="content">
            <img :src="getImageUrl(row)">
          </div>
          <img :src="getImageUrl(row)" style="width: 50px;height: 50px;">
        </Poptip>
      </template>
      <template slot-scope="{ row, index }" slot="uid">
        <span>{{ row.uid }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="sex">
        <span>{{ row.sex|getSex }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="status">
        <span>{{ row.status|getStatus }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button @click="openAuditPage(row)">预览</Button>
        <Button v-if="row.status === 1" @click="onShelves(row)" type="primary" style="margin-left: 5px;">上架</Button>
        <Button v-if="row.status === 0" :loading="loadingRows[row.id + '_pass']" @click="updateStatus(row, 1)" type="success" style="margin-left: 5px;">通过</Button>
        <Button v-if="row.status === 0" :loading="loadingRows[row.id + '_ignore']" @click="updateStatus(row, -1)" type="error" style="margin-left: 5px;">忽略</Button>
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../http/api";
import Host from "@/http/env";

export default {
  name: "faq",
  data() {
    return {
      image_for_shop: false,
      filterVipFree: [{label: '否', value: 0}, {label: '是', value: 1}],
      filterSex: [{label: '女', value: 0}, {label: '男', value: 1}],
      filterStatus: [{label: '正常', value: 0}, {label: '下架', value: -1}, {label: '赠品', value: -2}],
      classify: 1,
      room_type: 0,   // 0 家
      data: [],
      onRequest: false,
      columns: [
        {
          title: '套装ID',
          slot: 'id',
          width: 80
        },
        {
          title: '套装图',
          slot: 'url',
          width: 80
        },
        {
          title: '创作者',
          slot: 'uid',
          width: 120
        },
        {
          title: '性别',
          slot: 'sex',
          width: 120
        },
        {
          title: '状态',
          slot: 'status',
          width: 170
        },
        {
          title: '操作',
          slot: 'action',
          // width: 270
        }
      ],
      loadingRows: {} // 用于跟踪每个行的加载状态
    }
  },
  async created() {
    await this.getRecords();
    // 监听子页面的刷新事件
    this.$on('refresh-data', this.handleRefreshData);
  },
  
  beforeDestroy() {
    // 移除事件监听
    this.$off('refresh-data', this.handleRefreshData);
  },

  methods: {
    getImageUrl(item) {
      return `https://image.co-study.com.cn/${this.getCurrentSuitFolderName(item)}/${item.suit}`;
    },
    getCurrentSuitFolderName(item) {
      return item.status >=2 ? 'app/image/figure/suit/shop' : item.folder
    },
    openAuditPage(row) {
      let host ='https://data.co-study.com.cn'
      switch (Host.env){
        case 'pub':
          host ='https://data.co-study.com.cn'
              break
        case 'test':
          host ='http://data-test.co-study.com.cn'
              break
        default:
          host ='http://data.co-study.com.cn'
      }
      const url = `${host}/clothes.html?page=preview&id=${row.id}&uid=${row.uid}`;
      window.open(url, '_blank');
    },

    async getRecords() {
      let params = {}
      apis.figure_review_clothes_list(params).then(res => {
        const {data, errCode, msg} = res;
        if (errCode === 0) {
          this.data = data
        }
      }).catch(err => {

      })
    },
    
    // 处理子页面刷新数据的事件
    handleRefreshData(reviewId) {
      this.getRecords();
    },
    
    async updateStatus(row, status) {
      // 设置按钮加载状态
      const buttonKey = status === 1 ? row.id + '_pass' : row.id + '_ignore';
      this.$set(this.loadingRows, buttonKey, true);
      
      const params = {
        review_id: row.id,
        handle_status: status
      };
      
      try {
        if(status === 1){
          this.$Message.success('压缩中，时间较长，耐心等待');
        }
        const res = await apis.figure_review_clothes_status_update(params, status === 1 ? 90000 : 30000);
        const { errCode, msg } = res;
        if (errCode === 0) {
          this.$Message.success(status === 1 ? '通过成功' : '忽略成功');
          // 更新本地数据状态
          row.status = status;
        } else {
          this.$Message.error(msg || '操作失败');
          await this.getRecords()
        }
      } catch (error) {
        this.$Message.error('请求失败：' + error.message);
        await this.getRecords()
      } finally {
        // 移除按钮加载状态
        this.$set(this.loadingRows, buttonKey, false);
      }
    },
    
    async onShelves(row) {
      // 跳转到子页面，传递完整行数据
      console.log('test info ',JSON.stringify(row))
      // 将数据存储在 localStorage 中，并传递一个唯一标识符
      const uniqueId = 'figure_audit_row_data_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem(uniqueId, JSON.stringify(row));
      
      this.$router.push({
        path: `/shop/audit/figureAuditNew`,
        query: {
          shop_id: 1,
          shop_title: 'Co家族官方店铺',
          dataId: uniqueId  // 传递数据ID用于获取存储的数据
        }
      });
    }
  },
  computed: {},
  filters: {
    getSex(val) {
      if (val === 0) {
        return '女'
      } else if (val === 1) {
        return '男'
      }
    },

    getStatus(val) {
      if (val === 0) {
        return '待审核'
      } else if (val === -1) {
        return '已忽略'
      } else if (val === 1) {
        return '待上架'
      } else if (val === 2) {
        return '已上架'
      } else {
        return '未知'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.headers button {
  margin-left: 10px;
}
</style>